/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rev3_NameInputs */

const en_funnel_sq_rev3_name = /** @type {(inputs: Funnel_Sq_Rev3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priya S.`)
};

const es_funnel_sq_rev3_name = /** @type {(inputs: Funnel_Sq_Rev3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priya S.`)
};

/**
* | output |
* | --- |
* | "Priya S." |
*
* @param {Funnel_Sq_Rev3_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rev3_name = /** @type {((inputs?: Funnel_Sq_Rev3_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rev3_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rev3_name(inputs)
	return en_funnel_sq_rev3_name(inputs)
});